// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__8qaW2","fileBtn":"File_fileBtn__2L77j","closeBtn":"File_closeBtn__2lHto","fileSelected":"File_fileSelected__2rdq2","disabled":"File_disabled__1EM40"};